export default "/e891d4a0bdc60f2a6a9b4e97d7422547d2a79dc5/57a43ba76340ea303ae7dc89733370a0.svg";